// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Loading from '../../../../../components/Common/Loading';
import NotFound404 from '../../../../../components/Common/NotFound404';
import SuspenseComponent from '../../../../../components/Common/SuspenseComponent';
import { reactLazyRetry } from '../../../../../utils/Utils';
import { findMatchingEntityType } from '../../../../../utils/inventoryRouteEngine';

const EntityList = reactLazyRetry(
  () => import('../../../EntityOperations/EntityList')
);
const ModelInventoryCreateModel = reactLazyRetry(
  () => import('../../../EntityOperations/CreateModelStepper')
);
const ArchivedEntity = reactLazyRetry(
  () => import('../../../EntityOperations/ArchivedEntity')
);
const EntityDetailsAssembly = reactLazyRetry(
  () => import('../../EntityDetailsAssembly')
);

const DynamicEntityRoute = ({ variant }) => {
  const { entitySlug, entityAction, uniqueId } = useParams();
  const entityTypes = useSelector((state) => state?.tenant?.entityTypes || []);

  const matchedEntityType = React.useMemo(
    () => findMatchingEntityType(entityTypes, entitySlug, entityAction),
    [entityTypes, entitySlug, entityAction]
  );

  if (entityTypes.length === 0) {
    return <Loading />;
  }

  if (!matchedEntityType) {
    return <NotFound404 />;
  }

  if (variant === 'list') {
    return (
      <SuspenseComponent>
        <EntityList
          entity_label={matchedEntityType?.label}
          entity_value={matchedEntityType?.value}
        />
      </SuspenseComponent>
    );
  }

  if (variant === 'create') {
    return (
      <SuspenseComponent>
        <ModelInventoryCreateModel
          entityLabel={matchedEntityType?.label}
          entityValue={matchedEntityType?.value}
        />
      </SuspenseComponent>
    );
  }

  if (variant === 'archive') {
    return (
      <SuspenseComponent>
        <ArchivedEntity
          entityLabel={matchedEntityType?.label}
          entityValue={matchedEntityType?.value}
        />
      </SuspenseComponent>
    );
  }

  return (
    <SuspenseComponent>
      <EntityDetailsAssembly key={uniqueId || matchedEntityType?.value} />
    </SuspenseComponent>
  );
};

DynamicEntityRoute.propTypes = {
  variant: PropTypes.oneOf(['list', 'create', 'archive', 'details']).isRequired,
};

export default DynamicEntityRoute;
